
function Footer() {
    return (
        <footer className="App-footer">
            <p>Copyright &copy; 2025-2026 Worldwide Tang Soo (Soo Bahk) Do Union</p>
        </footer>
        );
}

export default Footer